import { cpf, cnpj } from 'cpf-cnpj-validator'

export default {
  cellphone(phone) {
    const rule = /\(\d{2,}\) \d{4,}\-\d{4}/
    return rule.test(phone)
  },

  cnpj(cnpjValue) {
    // @ts-ignore
    const rule = cnpj.isValid(cnpjValue)
    return rule
  },

  creditCard(number) {
    const rule = /^.{16}$/
    return rule.test(number)
  },

  crm(crm) {
    const rule = /^[0-9]*$/
    return rule.test(crm)
  },

  cpf(cpfValue) {
    // @ts-ignore
    const rule = cpf.isValid(cpfValue)
    return rule
  },

  cvv(number) {
    const rule = /^.{3,4}$/
    return rule.test(number)
  },

  email(email) {
    const rule = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return rule.test(email)
  },

  name(name) {
    const rule = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/
    return rule.test(name)
  },
}
